/* Auto-refresh status for a list that refreshes itself (Campaign reports, Campaign history).
   Sits in the list's footer, next to the page number, at a fixed width with tabular figures: as the seconds count
   down nothing beside it moves. The button pauses or resumes. */

import React from "react";
import styles from "./refreshStatus.module.css";
import { OI } from "../../onam/mark";

type Props = {
  seconds: number;
  /** paused by the person (the button resumes it) */
  paused: boolean;
  /** held while a popup, filter or menu is open; resumes by itself */
  held?: boolean;
  onPause: () => void;
  onResume: () => void;
};

export default function RefreshStatus({ seconds, paused, held, onPause, onResume }: Props) {
  const state = paused ? "paused" : held ? "held" : "live";
  return (
    <span className={styles.root} data-state={state}>
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.text} aria-live="off">
        {paused ? "Auto-refresh paused" : held ? "Auto-refresh on hold" : <>Refreshes in <b className={styles.num}>{seconds}s</b></>}
      </span>
      <button type="button" className={styles.btn} onClick={paused ? onResume : onPause}
        aria-label={paused ? "Resume auto-refresh" : "Pause auto-refresh"} title={paused ? "Resume auto-refresh" : "Pause auto-refresh"}>
        <OI n={paused ? "play" : "pause"} size={14} />
      </button>
    </span>
  );
}
